<template>
  <b-input-group class="ta-lot-keyword-search">
    <b-input-group-prepend is-text>
      <b-icon icon="search"></b-icon>
    </b-input-group-prepend>
    <b-form-input
      :placeholder="placeholder"
      :value="lotQueryParams.q"
      @change.native="updateFilters({q: $event.target.value})"></b-form-input>
  </b-input-group>
</template>

<script>
import {LOT_LIST_DEFAULT_PAGE} from "../../../constants";
import {updateLotsRoute} from "../../../helpers";
import {mapMutations, mapState} from "vuex";

export default {
  name: "LotKeywordSearch",
  props: {
    placeholder: {
      type: String,
      default() {
        return this.$t('Search for lots') + '...';
      }
    }
  },
  computed: {
    ...mapState(['lotQueryParams'])
  },
  methods: {
    ...mapMutations(['setLotFilters']),
    updateFilters(filters){
      filters.page = LOT_LIST_DEFAULT_PAGE;
      this.setLotFilters(filters)
      updateLotsRoute()
    },
  }
}
</script>

<style lang="scss" scoped>
.ta-lot-keyword-search {
  flex: 1;
  margin-bottom: 1rem;
}
</style>
